export { default } from './ImageMultipleChoice.js';
